const initGridFilters = () => {
  const filterBtns = document.querySelectorAll('.careline-product-grid-filters .button');
  const productGridEl = document.querySelectorAll('.careline-product-grid .multicolumn-card');

  if(!filterBtns || !productGridEl) {
    return false;
  }

  const toCamelCase = (str) => {
    return str.replace(/-([a-z])/g, (_, char) => char.toUpperCase());
  }

  const clearGridFilters = () => {
    filterBtns.forEach(btn => {
      btn.classList.remove('active');
    });
  }

  const filterProductGrid = (filter) => {
    productGridEl.forEach(product => {
      product.classList.remove('not-shown');
    });
    if(filter === 'clear'){
      clearGridFilters();
    } else {
      filterBtns.forEach(btn => {
        if(btn.classList.contains('active')) {
          let filterLoop = btn.dataset.filter;
          productGridEl.forEach(product => {
            let camelFilter = toCamelCase(`filter-${filterLoop}`);
            if(product.dataset[camelFilter] != 'true') {
              product.classList.add('not-shown');
            }
          });
        } 
      });
    }
  }

  const applyFilters = (event) => {
    if(event.target.dataset.filter == 'home' & document.querySelector('.careline-product-grid-filters .button[data-filter="away"]').classList.contains('active')) {
        document.querySelector('.careline-product-grid-filters .button[data-filter="away"]').classList.remove('active')
    } else if(event.target.dataset.filter == 'away' & document.querySelector('.careline-product-grid-filters .button[data-filter="home"]').classList.contains('active')) {
        document.querySelector('.careline-product-grid-filters .button[data-filter="home"]').classList.remove('active')
    }
    if(event.target.classList.contains('active')) {
      event.target.classList.remove('active');
    } else {
      event.target.classList.add('active');
    }
    filterProductGrid(event.target.dataset.filter);
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', applyFilters);
  });
  
}

initGridFilters();